@if (backButton) {
  <app-header [pageTitle]="'components.back-button' | translate"
              [mainPage]="false"
              [companySelectorDisabled]="false"
              [noInternetPage]="noInternetPage"
              (goBack)="goToPreviousPage()"/>
}
<ion-content class="container">
  <div class="body">
    <h3 class="title">{{title | translate: appName}}</h3>
    <p>{{body | translate}}</p>
    @if (storeLink) {
      <p class="link" (click)="openUrl()">{{storeLink}}</p>
    }
    <ion-img src="assets/icon/general-info.svg"/>
  </div>
  @if (termsAndConditionsModal) {
    <ion-button class="main-btn ion-padding-vertical"
                (click)="unregister()">
      {{'read-mode.unregister' | translate}}
    </ion-button>
  }
</ion-content>
